module.exports = __webpack_public_path__ + "assets/img/tracked-top.5f982251.svg";